import styled from 'styled-components';
import { pxToRem } from '@leaftrade/leaftrade-component-library';

export const CheckoutWrapper = styled.div`
  max-width: ${pxToRem(1140)};
  margin: 0 auto;
`;
